import { render, staticRenderFns } from "./Advertising2Groups.vue?vue&type=template&id=7acb37b4&scoped=true"
import script from "./Advertising2Groups.vue?vue&type=script&lang=js"
export * from "./Advertising2Groups.vue?vue&type=script&lang=js"
import style0 from "./Advertising2Groups.vue?vue&type=style&index=0&id=7acb37b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acb37b4",
  null
  
)

export default component.exports